module.exports = __webpack_public_path__ + "img/rand_money.f83a5d43.svg";